import { render } from "./ui-clipboard.vue?vue&type=template&id=0347c53f"
import script from "./ui-clipboard.vue?vue&type=script&lang=js"
export * from "./ui-clipboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__